// src/landing/pages/LegalPage.jsx
import React, { useState, useEffect, useContext } from 'react';
import { useSearchParams } from 'react-router-dom';
import NavBar from '../components/NavBar';
import TermsPage from './TermsPage';
import PrivacyPage from './PrivacyPage';
import FooterSection from '../components/FooterSection';
import '../styles/LegalPage.css'; 
import { LanguageContext } from '../../common/contexts/LanguageContext';

export default function LegalPage() {
  const { t } = useContext(LanguageContext);

  const [searchParams, setSearchParams] = useSearchParams();
  const initialTab = searchParams.get('tab') === 'privacy' ? 'privacy' : 'terms';
  const [activeTab, setActiveTab] = useState(initialTab);

  // URL 파라미터(tab) 변경 시 activeTab 동기화
  useEffect(() => {
    const tab = searchParams.get('tab') === 'privacy' ? 'privacy' : 'terms';
    setActiveTab(tab);
  }, [searchParams]);

  // 탭 클릭 시 상태와 URL 업데이트
  const switchTab = (tab) => {
    setActiveTab(tab);
    setSearchParams({ tab });
  };

  return (
    <>
      {/* 상단 네비게이션 */}
      <NavBar />

      {/* 탭 버튼 */}
      <div className="legal-tabs">
        <button
          className={`legal-tab ${activeTab === 'terms' ? 'active' : ''}`}
          onClick={() => switchTab('terms')}
        >
          {t('legalPage.tab.terms')}
        </button>
        <button
          className={`legal-tab ${activeTab === 'privacy' ? 'active' : ''}`}
          onClick={() => switchTab('privacy')}
        >
          {t('legalPage.tab.privacy')}
        </button>
      </div>

      {/* 탭 콘텐츠 */}
      <main className="legal-main">
        {activeTab === 'terms' ? <TermsPage /> : <PrivacyPage />}
      </main>

      {/* 하단 FooterSection */}
      <FooterSection />
    </>
  );
}
